export default "/images/content_creators.png?ebb3d4db13c898e60c8b613bdfd0b478";